import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import css_248z from './title-text.scss.js';
import { getStyleClassNames } from '../../utilities/constants/styles.constants.js';

class TitleText extends s {
    constructor() {
        super(...arguments);
        this.isRtl = false;
        this.text = '';
        this.fontSize = '1.5em';
        this.marginBottom = '0.5em';
        this.additionalClasses = '';
        this.textAlign = '';
    }
    render() {
        const containerClassNames = getStyleClassNames({
            marginBottom: this.marginBottom,
            additionalClasses: this.additionalClasses,
            isRtl: this.isRtl,
            textAlign: this.textAlign,
        });
        const titleClassNames = getStyleClassNames({
            fontSize: this.fontSize,
            isRtl: this.isRtl,
            additionalClasses: this.additionalClasses,
        });
        return x `<div class="title-text ${containerClassNames}"><h2 class="${titleClassNames}"><slot></slot></h2></div>`;
    }
}
TitleText.styles = css_248z;
__decorate([
    n({ type: Boolean })
], TitleText.prototype, "isRtl", void 0);
__decorate([
    n({ type: String })
], TitleText.prototype, "text", void 0);
__decorate([
    n({ type: String })
], TitleText.prototype, "fontSize", void 0);
__decorate([
    n({ type: String })
], TitleText.prototype, "marginBottom", void 0);
__decorate([
    n({ type: String })
], TitleText.prototype, "additionalClasses", void 0);
__decorate([
    n({ type: String })
], TitleText.prototype, "textAlign", void 0);
customElements.define('title-text', TitleText);

export { TitleText };
